/** A phone bezel with a notch around an app screenshot. */
export function PhoneFrame({ className, src, alt, imageClassName }) {
  return (
    <div className={className}>
      <span className="phone-notch" />
      <img className={imageClassName} src={src} alt={alt} />
    </div>
  );
}
